import { render, staticRenderFns } from "./DetailInfo.vue?vue&type=template&id=21059cb1&scoped=true&"
import script from "./DetailInfo.vue?vue&type=script&lang=ts&"
export * from "./DetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21059cb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21059cb1')) {
      api.createRecord('21059cb1', component.options)
    } else {
      api.reload('21059cb1', component.options)
    }
    module.hot.accept("./DetailInfo.vue?vue&type=template&id=21059cb1&scoped=true&", function () {
      api.rerender('21059cb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/rooms/DetailInfo.vue"
export default component.exports